var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("配送时间？")]),_c('div',{staticClass:"content-info"},[_c('p',{staticClass:"txt1"},[_vm._v("早7点至早11点。")])])])
}]

export { render, staticRenderFns }